import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";

gsap.registerPlugin(ScrollTrigger);

// mobile nav functionality
let mobileNav = document.getElementById("mobile-nav");
let navBtn = document.getElementById("mobile-nav-btn");
let navEx = document.getElementById("nav-menu-exit-btn");

const mobileNavOpenTl = gsap.timeline();
const mobileNavCloseTl = gsap.timeline();

// if (navEx) {
//   navEx.addEventListener("click", function () {
//     if (mobileNav.classList.contains("mobile-nav-active")) {

//       setTimeout(() => {
//         mobileNav.classList.remove("mobile-nav-active");
//       }, 900);
//     }
//   });
// }
if (navBtn) {
  navBtn.addEventListener("click", function () {
    if (!mobileNav.classList.contains("mobile-nav-active")) {
      mobileNav.classList.add("mobile-nav-active");
      mobileNavOpenTl.fromTo(
        mobileNav,
        { y: "0%" },
        { y: "100%", ease: "power3.out", duration: 1 }
      );
    } else {
      mobileNavCloseTl.fromTo(
        mobileNav,
        { y: "100%" },
        { y: "0%", ease: "power3.out", duration: 1 }
      );
      mobileNav.classList.remove("mobile-nav-active");
    }
  });
}

let bgColor;
if (document.body) {
  bgColor = document.body.id.split("body-")[1];
}

// large swiper
const largeSwiper = new Swiper(".large-swiper", {
  modules: [Autoplay, Pagination],
  // Optional parameters
  loop: true,
  pagination: {
    el: ".large-swiper-swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return (
        `<button class="bullet bullet-${bgColor ? bgColor : "green"} ` +
        className +
        '"></button>'
      );
    },
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

const largeSwiperImages = document.querySelectorAll(".large-swiper-bg-image");
if (largeSwiperImages.length) {
  largeSwiper.on("slideChange", function () {
    for (let i = 0; i < largeSwiperImages.length; i++) {
      let el = largeSwiperImages[i];
      let elId = el.id.split("large-swiper-img-")[1];

      if (largeSwiper.realIndex === parseInt(elId)) {
        gsap.to(el, { opacity: 1 });
      } else {
        gsap.to(el, { opacity: 0 });
      }
    }
  });
}

// testimonial swiper
const testimonialSwiper = new Swiper(".testimonial-swiper", {
  modules: [Autoplay, Pagination],
  // Optional parameters
  loop: true,
  pagination: {
    el: ".testimonial-swiper-swiper-pagination",
    clickable: true,
    renderBullet: function (index, className) {
      return '<button class="bullet ' + className + '"></button>';
    },
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

// section swiper
const sectionSwiper = new Swiper(".section-swiper", {
  modules: [Navigation],
  // Optional parameters
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: ".section-swiper-button-next",
    prevEl: ".section-swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 50,
    },
  },
});

// Alerts Timeline
const activeAlertRows = document.querySelectorAll(".alert-row");

for (let i = 0; i < activeAlertRows.length; i++) {
  const alertRow = activeAlertRows[i];
  const alertLines = alertRow.querySelectorAll(".alert-line");

  const alertTimeline = new gsap.timeline({
    onComplete: function () {
      this.restart();
    },
  });
  if (alertLines.length && alertLines.length > 1) {
    for (let i = 0; i < alertLines.length; i++) {
      const el = alertLines[i];
      alertTimeline
        .to(el, { opacity: 1, duration: 0.3 })
        .to(el, { opacity: 0, duration: 0.3 }, "<3");
    }
  } else {
    for (let i = 0; i < alertLines.length; i++) {
      const el = alertLines[i];
      el.style.opacity = 1;
    }
  }
}

// External Link Checker
const host = window.location.hostname;
const allAnchors = document.querySelectorAll("a");

if (allAnchors.length) {
  for (let i = 0; i < allAnchors.length; i++) {
    const el = allAnchors[i];
    if (
      el.href.includes(host) ||
      el.href.includes("tel:") ||
      el.href.includes("mailto:")
    ) {
    } else {
      el.classList.add("ext");
    }
  }
}

window.addEventListener("load", function () {
  // External Link onClick
  const allExternalLinks = document.querySelectorAll(".ext");
  const extModal = document.getElementById("ext-modal");
  const extModalCloseBtn = document.getElementById("ext-modal-close");
  let extModalContinueBtn = document.getElementById("ext-modal-continue");

  if (allExternalLinks.length) {
    for (let i = 0; i < allExternalLinks.length; i++) {
      const el = allExternalLinks[i];
      if (!el.classList.contains("login-link")) {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          if (extModal && extModalCloseBtn && extModalContinueBtn) {
            console.log(e);
            extModal.classList.remove("hidden");
            extModalContinueBtn.href = e.currentTarget.href;
            console.log(e.currentTarget.href);
          }
        });
      }
    }
  }

  if (extModalCloseBtn && extModal) {
    extModalCloseBtn.addEventListener("click", () => {
      extModal.classList.add("hidden");
    });
  }
});

const loginExtModal = document.getElementById("login-ext-modal");
const loginExtModalOpenBtns = document.querySelectorAll(
  ".login-ext-modal-open"
);
const loginExtModalCloseBtn = document.getElementById("login-ext-modal-close");

if (loginExtModal) {
  for (let i = 0; i < loginExtModalOpenBtns.length; i++) {
    const el = loginExtModalOpenBtns[i];
    el.addEventListener("click", () => {
      e.preventDefault();
      loginExtModal.classList.remove("hidden");
    });
  }

  loginExtModalCloseBtn.addEventListener("click", () => {
    e.preventDefault();
    loginExtModal.classList.add("hidden");
  });
}
